module.exports = __webpack_public_path__ + "21-o1.jpg?7166692d6b4c34623e7e5f798c2348d8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/21-o1.jpg
// module id = 642
// module chunks = 0